const domain = SEVSRS;
//救援公司用
var pt2txt = function (pts) {
    var pt = new Object;
    pt.pts=pts;
    if (pts == 100) { pt.node = "案件已创立"; pt.phase = "案件已创立";pt.nodeEn = "Case created"; pt.phaseEn = "Case created"; }
    if (pts == 110) { pt.node = "案件已完成"; pt.phase = "救援案件完成"; }
    if (pts == 111) { pt.node = "案件已关闭"; pt.phase = "案件已关闭"; }
    if (pts == 112) { pt.node = "拒绝启动救援"; pt.phase = "拒绝启动救援"; }
    if (pts == 113) { pt.node = "案件已取消"; pt.phase = "案件已取消"; }
    if (pts == 120) { pt.node = "启动救援中"; pt.phase = "启动救援中：等待监管机构授权中";pt.nodeEn = "Initiating rescue"; pt.phaseEn = "Initiating rescue: Waiting for the supervision department to authorize"; }
    if (pts == 130) { pt.node = "授权通过"; pt.phase = "授权通过：监管机构已授权";pt.nodeEn = "The authorization has been approved"; pt.phaseEn = "The authorization has been approved: Supervision department has authorized"; }
    if (pts == 140) { pt.node = "救援公司报价中"; pt.phase = "报价中：转交救援公司获取报价中";pt.nodeEn = "Assistance company is quoting"; pt.phaseEn = "Quotation: waiting for quotation from assistance service providers"; }
    if (pts == 150) { pt.node = "指挥中心已确认"; pt.phase = "已确认救援方案及报价"; }
    if (pts == 160) { pt.node = "监管机构已授权"; pt.phase = "已授权：确认救援方案及报价"; }
    if (pts == 180) { pt.node = "指挥中心确认开始救援"; pt.phase = "指挥中心确认开始救援";pt.nodeEn = "Service in progress as authorized by the Control Center"; pt.phaseEn = "Service in progress as authorized by the Control Center"; }
		if (pts == 190) { pt.node = "救援完成待确认"; pt.phase = "救援完成待确认";pt.nodeEn = "Pending confirmation of rescue"; pt.phaseEn = "Pending confirmation of rescue"; }
    if (pts == 90) { pt.node = "App报案"; pt.phase = "App用户，报案" }
    if (pts == 114) { pt.node = "分公司拒绝派单"; pt.phase = "星使派单" }
    if (pts == 115) { pt.node = "总司调处拒绝派单"; pt.phase = "星使派单" }
    if (pts == 210) { pt.node = "等待分公司确认"; pt.phase = "星使派单" }
    if (pts == 211) { pt.node = "等待总司调处确认"; pt.phase = "星使派单" }
    if (pts == 230) { pt.node = "进入正常流程，等待海外代表接入，或直接接单等后续流程"; pt.phase = "星使派单" }
    return pt;
};
// 指挥中心用
var pt2txt2 = function (pts) {
    var pt = new Object;
    pt.pts=pts;
    if (pts == 100) { pt.node = "案件已创立"; pt.phase = "案件已创立"; }
    if (pts == 110) { pt.node = "案件已完成"; pt.phase = "救援案件完成"; }
    if (pts == 111) { pt.node = "案件已关闭"; pt.phase = "案件已关闭"; }
    if (pts == 112) { pt.node = "拒绝启动救援"; pt.phase = "拒绝启动救援"; }
    if (pts == 113) { pt.node = "案件已取消"; pt.phase = "案件已取消"; }
    if (pts == 120) { pt.node = "启动救援中"; pt.phase = "启动救援中：等待监管机构授权中"; }
    if (pts == 130) { pt.node = "授权通过"; pt.phase = "授权通过：监管机构已授权"; }
    if (pts == 140) { pt.node = "救援公司报价中"; pt.phase = "报价中：转交救援公司获取报价中"; }
    if (pts == 150) { pt.node = "指挥中心已确认"; pt.phase = "已确认救援方案及报价"; }
    if (pts == 160) { pt.node = "监管机构已授权"; pt.phase = "已授权：确认救援方案及报价"; }
    if (pts == 180) { pt.node = "指挥中心确认开始救援"; pt.phase = "指挥中心确认开始救援"; }
		if (pts == 190) { pt.node = "救援完成待确认"; pt.phase = "救援完成待确认"; }
    if (pts == 90) { pt.node = "App报案"; pt.phase = "App用户，报案" }

    return pt;
};

// 监管中心用
var pt2txt3 = function (pts) {
    var pt = new Object;
    pt.pts=pts;
    if (pts == 100) { pt.node = "案件已创立"; pt.phase = "案件已创立"; }
    if (pts == 110) { pt.node = "案件已完成"; pt.phase = "救援案件完成"; }
    if (pts == 111) { pt.node = "案件已关闭"; pt.phase = "案件已关闭"; }
    if (pts == 112) { pt.node = "拒绝启动救援"; pt.phase = "拒绝启动救援"; }
    if (pts == 113) { pt.node = "案件已取消"; pt.phase = "案件已取消"; }
    if (pts == 120) { pt.node = "启动救援中"; pt.phase = "启动救援中：等待监管机构授权中"; }
    if (pts == 130) { pt.node = "授权通过"; pt.phase = "授权通过：监管机构已授权"; }
    if (pts == 140) { pt.node = "救援公司报价中"; pt.phase = "报价中：转交救援公司获取报价中"; }
    if (pts == 150) { pt.node = "指挥中心已确认"; pt.phase = "已确认救援方案及报价"; }
    if (pts == 160) { pt.node = "监管机构已授权"; pt.phase = "已授权：确认救援方案及报价"; }
    if (pts == 180) { pt.node = "指挥中心确认开始救援"; pt.phase = "指挥中心确认开始救援"; }
    if (pts == 90) { pt.node = "App报案"; pt.phase = "App用户，报案" }

    return pt;
};

var time=function(ts) {
    if(ts==null) return '';
    var d = new Date(ts); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = d.getFullYear() + "-";
    var M =(d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1)  : d.getMonth() + 1) + "-";
    var D = d.getDate() < 10 ? '0'+ d.getDate(): d.getDate();
    var h = d.getHours() < 10 ? '0'+ d.getHours() + ":" : d.getHours() + ":";
    var m = d.getMinutes() < 10 ? '0'+ d.getMinutes() + ":" : d.getMinutes() + ":";
    var s = d.getSeconds() < 10 ? '0'+ d.getSeconds() : d.getSeconds();
    // console.log(Y +"-" + M + "-" +D +"-"+ h +"-"+ m +"-"+ s)
    if(d.getHours()==0&&d.getMinutes()==0&&d.getSeconds()==0){
      return Y + M + D+' '+ '00:00:00';
    }
    return Y + M + D +' '+ h + m + s;
  };

  var strHidden =function(str,len){
    if(str == null || str == undefined || str == "") return '';
    var h = "*";
    var size = str.length;
    var r = "";
    if(len){
      if(size<=len){
        for(var i=0;i<size;i++){
            r+=h;
        }
      }else{
        r = str.substr(0,len);
        for(var i=0;i<(size-len);i++){
          r+=h;
        }
      }
    }else{
      for(var i=0;i<size;i++){
        r+=h;
      }
    }
    return r;
  };

  var isPic=function(s){
    if(s==null||s=="")
        return false;
    var ss=s.toUpperCase();
    return endWith(ss,"JPG")||endWith(ss,"PNG");
  };

  function endWith(str,s){
    if(s==null||s==""||str==null||str==""||str.length==0||s.length>str.length)
        return false;
    if(str.substring(str.length-s.length)==s)
        return true;
    else
        return false;
  };

  var state2op = function (caseState,state) {
    var op = "";
    if (caseState == 100) { op = "指挥中心"; }
    if (caseState == 120) { op = "监管机构"; }
    if (caseState == 130) { op = "指挥中心"; }
    if (caseState == 140) {
       op = "指挥中心";
       if(state!=null && state == 0){
         op = "救援机构";
       }
    }
    if (caseState == 150) { op = "监管机构"; }
    if (caseState == 160) { op = "指挥中心"; }
    if (caseState == 180) { op = "救援机构"; }

    return op;
};
var setTxt = function(str,status = 'zh'){
	// debugger
		var txt = str,zhString='',enString='';
		var reg =/(<zh-CN([^>]*)>)(.*)(<\/zh-CN([^>]*)>)/gmi;
		if(txt == null ) return false
		txt=txt.replace(/\n/g,'')
		if(txt.match(reg) == null ) return false
		var zhTxt=txt.match(reg).toString();
		var reg1 =/(<en-US([^>]*)>)(.*)(<\/en-US([^>]*)>)/gmi;
		var enTxt=txt.match(reg1).toString();
		if(status == 'zh'){
			if(zhTxt.substring(7,zhTxt.length-8) == ''){
				if(enTxt.substring(7,enTxt.length-8) == ''){
					zhString='未填写'
				}else{
					zhString=enTxt.substring(7,enTxt.length-8)
				}

			}else{
				zhString=zhTxt.substring(7,zhTxt.length-8)
			}
			if(reg.test(zhString)){
				return setTxt(zhString,status)
			}
			return zhString
		}else{
			if(enTxt.substring(7,enTxt.length-8) == ''){
				if(zhTxt.substring(7,zhTxt.length-8) == ''){
					enString='not filled'
				}else{
					enString=zhTxt.substring(7,zhTxt.length-8)
				}
			}else{
				enString=enTxt.substring(7,enTxt.length-8)
			}
			return enString
		}
	}

var ptXingshitxt3 = function (pts) {//星使派单
    var pt = new Object;
    pt.pts=pts;
    if (pts == 101) { pt.node = "人员加入"; pt.phase = "星使"; }
    if (pts == 102) { pt.node = "人员离开"; pt.phase = "星使"; }
    if (pts == 103) { pt.node = "人员加入"; pt.phase = "星使"; }
    if (pts == 104) { pt.node = "人员离开"; pt.phase = "星使"; }
    if (pts == 105) { pt.node = "进展"; pt.phase = "星使"; }
    if (pts == 106) { pt.node = "视频通话"; pt.phase = "星使"; }
    if (pts == 107) { pt.node = "信息更新"; pt.phase = "星使"; }
    if (pts == 108) { pt.node = "附件上传"; pt.phase = "星使"; }
    if (pts == 109) { pt.node = "简报"; pt.phase = "星使"; }
    if (pts == 110) { pt.node = "点后"; pt.phase = "星使"; }
    if (pts == 112) { pt.node = "进展"; pt.phase = "星使"; }
    return pt;
};
export default {domain,pt2txt,time,pt2txt2,pt2txt3,isPic,strHidden,state2op,setTxt,ptXingshitxt3}



// WEBPACK FOOTER //
// ./src/util/constants.js